import styles from "../../styles/common/index.module.css";
import Container from "@mui/material/Container";
import { useQuickStatsData } from "../../lib/hooks";
import { Skeleton } from "@mui/material";
import { toShortNumber } from "../../lib/util";

const StatsBar = () => {
  const { loading, statsData, error } = useQuickStatsData();
  return (
    <div className={styles.second_outer}>
      {/* <Container>
      <h3>STATISTICS</h3>
    </Container> */}
      <div className={styles.statistic_dv}>
        <Container>
          <div className={styles.statistic_inner}>
            {loading &&
              Object.keys(statsData).map((item: any, index) => (
                <div className={styles.statistic1} key={index}>
                  {/* <h2> */}
                  <Skeleton
                    variant="text"
                    sx={{ fontSize: "2rem" }}
                    width={80}
                  />
                  <Skeleton variant="text" sx={{ fontSize: "2rem" }} />
                  {/* </h2> */}
                </div>
              ))}

            {!loading && error === null && (
              <>
                <div className={styles.statistic1}>
                  <h2>
                    {toShortNumber(statsData.no_of_funds, "comma")}
                    <span>Funds</span>
                  </h2>
                </div>
                <div className={styles.statistic1}>
                  <h2>
                    {toShortNumber(statsData.regular_challenges, "comma")}
                    <span>Challenges</span>
                  </h2>
                </div>
                <div className={styles.statistic1}>
                  <h2>
                    {toShortNumber(statsData.total_proposals, "comma")}
                    <span>Proposals</span>
                  </h2>
                </div>
                <div className={styles.statistic1}>
                  <h2>
                    {toShortNumber(statsData.funded_proposals, "comma")}
                    <span>Projects</span>
                  </h2>
                </div>

                <div className={styles.statistic1}>
                  <h2>
                    ${toShortNumber(statsData.fund_budget)}
                    <span>Total Budget</span>
                  </h2>
                </div>
                <div className={styles.statistic1}>
                  <h2>
                    {" "}
                    ${toShortNumber(statsData.amount_requested)}
                    <span>Requested Amount</span>
                  </h2>
                </div>
                <div className={styles.statistic1}>
                  <h2>
                    ${toShortNumber(statsData.funded_amount)}
                    <span>Funded Amount</span>
                  </h2>
                </div>
              </>
            )}
          </div>
        </Container>
      </div>
    </div>
  );
};

export default StatsBar;
